import { ChatService } from "@/services";
import { CHAT_QUERY_KEYS } from "@/types";
import { useQuery } from "@tanstack/react-query";

export const useGetChat = (id: number) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [CHAT_QUERY_KEYS.CHAT_BY_ID, id],
    queryFn: () => ChatService.getChatById(id),
    retry: 1,
  });

  // throw error to catch by react error boundary
  if (error) throw error;

  return {
    chat: data?.data,
    isLoading,
  };
};
